import React, { useEffect, useContext, useState, useMemo } from 'react';
import useModelPagamento from './useModelPagamento';
import useModelCartao from './useModelCartao';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import { AccountContext } from 'components/AccountContext';
import { Box, Button, Center, Flex, Grid, Image, Skeleton, Text, HStack } from '@chakra-ui/react';
import { getAppTheme, userIsSubscriber } from '../../Utils/theme';
import Cards from '../Pagamento/Icons/Cards';
import Detalhes from '../../../images/Pagamento/detalhesCartao.svg';
import { DownloadIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';
function getMonthName(monthNumber) {
  const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  return months[monthNumber - 1] || '';
}

function CartoesSalvos(props) {
  const { theme, cards } = props;
  const themeApp = theme;
  const [cartoes, setCartoes] = useState(cards);
  const navigate = useNavigate();

  function ordenarCartoes(lista) {
    if (!Array.isArray(lista)) return [];
    return [...lista].sort((a, b) => (b.default === true ? 1 : 0) - (a.default === true ? 1 : 0));
  }

  useEffect(() => {
    setCartoes(ordenarCartoes(cards));
  }, [cards]);

  return (
    <>
      <Box bg={'#F3F3F3'}>
        <Flex alignItems="center" justifyContent="space-between" m={8} mb={4}>
          <Text color="#585858" fontWeight="bold" fontSize="lg">
            Cartões salvos
          </Text>

          <Text
            bg={themeApp?.background}
            color={themeApp?.fontcolor}
            borderRadius="0.8em"
            fontSize="sm"
            px={2}
            py={1}
            cursor="pointer"
            onClick={() => {
              navigate('/perfil/pagamento/cadastro-cartao', { state: { themeApp } });
            }}
          >
            Adicionar cartão
          </Text>
        </Flex>

        <Box overflowX="auto" whiteSpace="nowrap" px={8}>
          {cartoes?.map((card, index) => (
            <Box
              key={index}
              position="relative"
              display="inline-block"
              bg="white"
              borderRadius="0.8em"
              minW="180px"
              maxW="220px"
              h="110px"
              mr={4}
              p={4}
              mb={'1em'}
              onClick={() => {
                navigate('/perfil/pagamento/detalhes-cartao', {
                  state: {
                    card,
                    themeApp,
                  },
                });
              }}
            >
              <Image src={Detalhes} position="absolute" top="8px" right="8px" boxSize="16px" cursor="pointer" />

              <Flex direction="column" justify="space-between" h="100%">
                <Flex direction="column" gap={2}>
                  <Cards color={themeApp?.background} />
                  <Text color="#585858" fontSize="sm">
                    {card.brand}
                  </Text>
                  <Text color="#585858" fontSize="sm">
                    {card.last_digits}
                  </Text>
                </Flex>

                {card.default === true && (
                  <Flex justify="flex-end" mt={-2}>
                    <Text as="span" color={theme.background} fontWeight="bold" fontSize="12px" borderRadius="0.8em" px={3} py={1}>
                      {'Principal'}
                    </Text>
                  </Flex>
                )}
              </Flex>
            </Box>
          ))}
        </Box>
      </Box>
    </>
  );
}

function ProximasMensalidades(props) {
  const { theme, mensalidades, loading, descricao_plano } = props;
  const themeApp = theme;
  const mensalidadeLimit = !loading && mensalidades ? mensalidades?.slice(0, 5) : [];
  const navigate = useNavigate();

  return (
    <>
      <Box>
        <Flex alignItems="center" justifyContent="space-between" m={8} mb={4}>
          <Text color="#585858" fontWeight="bold" fontSize="lg">
            Próximas mensalidades
          </Text>

          <Text
            bg={themeApp?.background}
            color={themeApp?.fontcolor}
            borderRadius="0.8em"
            fontSize="sm"
            px={2}
            py={1}
            cursor="pointer"
            onClick={() => {
              if (loading) return;
              navigate('/perfil/mensalidade-detalhes', {
                state: {
                  mensalidades,
                  themeApp,
                  descricao_plano,
                },
              });
            }}
          >
            Detalhes
          </Text>
        </Flex>
        <Box overflowX="auto" whiteSpace="nowrap" px={8}>
          {loading ? (
            <>
              <Box
                as={Skeleton}
                position="relative"
                display="inline-block"
                bg="#F3F3F3"
                borderRadius="0.8em"
                minW="180px"
                maxW="220px"
                mr={4}
                p={4}
                mb={'1em'}
                onClick={() => {
                  console.log('detalhes');
                }}
              >
                <Flex direction="column" gap={2} mb={2}>
                  <Text as="span" color="#888888" fontWeight="bold" fontSize="lg" as={Skeleton}>
                    Fevereiro
                  </Text>

                  <Text color="#585858" fontSize="20px">
                    <Text as="span" fontWeight="bold" color={'#5AB2AE'} as={Skeleton}>
                      50
                    </Text>
                  </Text>
                </Flex>

                <Flex gap="2" flexWrap="wrap" mt="0.5em">
                  <Text color="#585858" fontSize="sm" as={Skeleton}>
                    Plano:{' '}
                    <Text as="span" color="#888888" fontWeight="bold" as={Skeleton}>
                      Familia
                    </Text>
                  </Text>

                  <Text color="#585858" fontSize="sm" as={Skeleton}>
                    Vencimento:{' '}
                    <Text as="span" color="#888888" fontWeight="bold">
                      11/02
                    </Text>
                  </Text>
                </Flex>
              </Box>
            </>
          ) : mensalidadeLimit?.length > 0 ? (
            mensalidadeLimit.map((mensalidade, index) => {
              const dataExtenso = new Date(mensalidade.data).toLocaleString('pt-BR', { month: 'long' });
              const anoMensalidade = new Date(mensalidade.data).getFullYear();
              if (mensalidade?.excluido) return;
              return (
                <Box
                  key={index}
                  position="relative"
                  display="inline-block"
                  bg="#F3F3F3"
                  borderRadius="0.8em"
                  minW="180px"
                  maxW="220px"
                  mr={4}
                  p={4}
                  mb={'1em'}
                  onClick={() => {
                    navigate('/perfil/pagamento/pagar-parcela', {
                      state: {
                        theme,
                        mensalidade,
                        descricao_plano,
                      },
                    });
                  }}
                >
                  <Flex direction="column" gap={2} mb={2}>
                    <Flex justify="space-between" align="center">
                      <Text as="span" color="#888888" fontWeight="bold" fontSize="lg">
                        {dataExtenso.charAt(0).toUpperCase() + dataExtenso.slice(1)} {anoMensalidade}
                      </Text>
                      <Text
                        as="span"
                        color="white"
                        fontWeight="bold"
                        fontSize="12px"
                        borderRadius="0.8em"
                        bg={mensalidade?.ativo === false ? theme.background : new Date(mensalidade.data) < new Date() ? '#D60000' : '#5AB2AE'}
                        px={3}
                        py={1}
                      >
                        {mensalidade?.ativo === false ? 'Paga' : new Date(mensalidade.data) < new Date() ? 'Vencida' : 'Aberta'}
                      </Text>
                    </Flex>
                    <Text color="#585858" fontSize="20px">
                      <Text
                        as="span"
                        fontWeight="bold"
                        color={mensalidade?.ativo === false ? theme.background : new Date(mensalidade.data) < new Date() ? '#D60000' : '#5AB2AE'}
                      >
                        {new Intl.NumberFormat('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(parseFloat(mensalidade.valor))}
                      </Text>
                    </Text>
                  </Flex>

                  <Flex gap="2" flexWrap="wrap" mt="0.5em">
                    <Text color="#585858" fontSize="sm">
                      Plano:{' '}
                      <Text as="span" color="#888888" fontWeight="bold">
                        {descricao_plano.charAt(0).toUpperCase() + descricao_plano.slice(1).toLowerCase()}
                      </Text>
                    </Text>

                    <Text color="#585858" fontSize="sm">
                      Vencimento:{' '}
                      <Text as="span" color="#888888" fontWeight="bold">
                        {new Date(mensalidade.data).toLocaleDateString('pt-BR', {
                          day: '2-digit',
                          month: '2-digit',
                          year: 'numeric',
                        })}
                      </Text>
                    </Text>
                  </Flex>
                </Box>
              );
            })
          ) : (
            <>
              <Text color="#585858" fontSize="sm">
                Não há próximas mensalidades disponíveis
              </Text>
            </>
          )}
        </Box>
      </Box>
    </>
  );
}

function PagamentosMes({ mes, parcelas }) {
  const { user } = useContext(AccountContext);
  return (
    <Box key={mes} borderBottom={'2px solid #EBEBEB'} pb={4}>
      <Text color={'#585858'} fontWeight={'bold'} fontSize={'lg'}>
        {mes}
      </Text>
      {parcelas.map((parcela) => {
        return (
          <Grid templateColumns="2fr 1fr" mt={4} key={parcela.paciente_contrato_parcelas_id}>
            <Box>
              <Text fontSize={'sm'}>Assinatura Plano {user.descricao_plano}</Text>
              <Text fontSize={'xs'} color={'#585858'}>
                Forma de pagamento: {parcela.forma_pagamento_fatura}
              </Text>
              <Text fontSize={'xs'} color={'#585858'}>
                {parcela.forma_pagamento_id === 12 || parcela.forma_pagamento_id === '12'
                  ? !parcela.parcela || parcela.parcela === '0' || parcela.parcela === 0 || parcela.parcela === 1
                    ? ` `
                    : 'Parcelado em ' + parcela.parcela + 'x'
                  : ''}
              </Text>
              <Text fontSize={'xs'} color={'#585858'}>
                Vencimento: {new Date(parcela.data).toLocaleDateString('pt-BR')}
              </Text>
              <Text fontSize={'xs'} color={'#585858'}>
                Pagamento: {new Date(parcela.data_pagamento).toLocaleDateString('pt-BR')}
              </Text>
            </Box>
            <Center>
              <Text color={'#585858'} fontWeight={'bold'}>
                {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(parseFloat(parcela.valor))}
              </Text>
            </Center>
          </Grid>
        );
      })}
    </Box>
  );
}

function HistoricoPagamentos(props) {
  const { theme, mensalidades, loading, descricao_plano, parcelas } = props;
  const [isReady, setIsReady] = useState(false);
  const themeApp = theme;
  const navigate = useNavigate();

  const filteredParcelas = useMemo(() => {
    if (loading || !parcelas) return [];
    return parcelas.slice(0, 3);
  }, [loading, parcelas]);

  const groupedParcelas = useMemo(() => {
    const groups = new Map();
    filteredParcelas.forEach((parcela) => {
      const date = new Date(parcela.data_pagamento);
      const key = `${getMonthName(date.getMonth() + 1)} ${date.getFullYear()}`;
      if (!groups.has(key)) {
        groups.set(key, []);
      }
      groups.get(key).push(parcela);
    });
    return groups;
  }, [filteredParcelas]);

  useEffect(() => {
    if (!loading && filteredParcelas.length > 0) {
      setIsReady(true);
    } else {
      setIsReady(true);
    }
  }, [loading, filteredParcelas]);

  return (
    <>
      <Box>
        <Flex alignItems="center" justifyContent="space-between" m={8} mb={4}>
          <Text color="#585858" fontWeight="bold" fontSize="lg">
            Histórico de pagamentos
          </Text>

          <Text
            bg={themeApp?.background}
            color={themeApp?.fontcolor}
            borderRadius="0.8em"
            fontSize="sm"
            px={2}
            py={1}
            cursor="pointer"
            onClick={() => {
              if (loading) return;
              navigate('/perfil/historico-pagamentos', {
                state: {
                  parcelas: parcelas,
                },
              });
            }}
          >
            Ver tudo
          </Text>
        </Flex>
        {!isReady ? (
          <>
            <Box>
              <Flex flexDirection={'column'} gap={8} p={8}>
                {[1, 2, 3].map((_, index) => {
                  return (
                    <Box key={index} borderBottom={'2px solid #EBEBEB'} pb={4}>
                      <Text as={Skeleton} rounded={'xl'} fontWeight={'bold'} fontSize={'lg'} maxW={'50%'}>
                        &nbsp;
                      </Text>
                      <Grid templateColumns="2fr 1fr" mt={4}>
                        <Box>
                          <Box as={Skeleton} rounded={'xl'}>
                            <Text fontSize={'sm'}>Assinatura Plano Família Total</Text>
                            <Text fontSize={'xs'}>Forma de pagamento: Pix - Pagarme</Text>
                            <Text fontSize={'xs'}>Data: 01/01/2001</Text>
                          </Box>
                          <Button
                            as={Skeleton}
                            disabled
                            mt={2}
                            size={'xs'}
                            rounded={'full'}
                            rightIcon={<DownloadIcon />}
                            // onClick={disclosureAno.onOpen}
                          >
                            Baixar Nota Fiscal
                          </Button>
                        </Box>
                        <Center>
                          <Text as={Skeleton} rounded={'xl'} fontWeight={'bold'}>
                            {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(99.99)}
                          </Text>
                        </Center>
                      </Grid>
                    </Box>
                  );
                })}
              </Flex>
            </Box>
          </>
        ) : (
          <>
            <Flex flexDirection={'column'} gap={8} p={8} mt={'-1em'}>
              {groupedParcelas.size ? (
                [...groupedParcelas.entries()].map(([mes, parcelas]) => <PagamentosMes key={mes} mes={mes} parcelas={parcelas} />)
              ) : (
                <>
                  <Text color="#585858" fontSize="sm">
                    Não foi possível encontrar histórico de pagamentos
                  </Text>
                </>
              )}
            </Flex>
          </>
        )}
      </Box>
    </>
  );
}

function MenuPagamento() {
  const { setPage, user, setUser } = useContext(AccountContext);

  const { searchMensalidades, mensalidades, error, loading, searchPagamentos, parcelas } = useModelPagamento(user?.id_contrato);
  const { searchCartoesAtualizados } = useModelCartao({ clientId: user.id_cliente_deovita });

  useEffect(() => {
    setPage('Pagamento');
    if (user?.id_contrato) {
      searchMensalidades();
      searchPagamentos();
    }
    console.log('atualiou os cartões');
    searchCartoesAtualizados();
  }, [setPage, user?.id_contrato]);
  const themeApp = getAppTheme(userIsSubscriber(user));

  return (
    <>
      <ChildHeader />

      <CartoesSalvos theme={themeApp} cards={user?.cards} />
      {user?.id_contrato ? (
        <>
          <ProximasMensalidades theme={themeApp} mensalidades={mensalidades} loading={loading} descricao_plano={user?.descricao_plano} />
          <HistoricoPagamentos theme={themeApp} parcelas={parcelas} loading={loading} />
        </>
      ) : null}
    </>
  );
}

export default MenuPagamento;
